import React from 'react';
const getTotal = (moduleData: any, key: any) => {
  return moduleData.reduce((sum: any, obj: any) => sum + +obj[key], 0);
};
const TFoot = ({ moduleData }: any) => {
  return (
    <tr style={{ background: '#38d9a9' }}>
      <th align="center"></th>
      <th colSpan={2} align="center">
        Average (in hrs)
      </th>
      <th align="center">
        TOTAL AVL. TIME : {getTotal(moduleData, 'available_time')}
      </th>
      <th align="center">
        TOTAL DOWN TIME : {getTotal(moduleData, 'down_time')}
      </th>
      <th align="center">
        TOTAL NO. OF DOWN TIME : {getTotal(moduleData, 'count_down_time')}
      </th>
      <th align="center">TOTAL MTBF : {getTotal(moduleData, 'mtbf')}</th>
      <th align="center">TOTAL MTTR : {getTotal(moduleData, 'mttr')}</th>
    </tr>
  );
};

export default TFoot;
